import _get from 'lodash.get';
import createSlideshow from '../modules/slideshow/create_slideshow';
import getByTypeFetcher from '../services/get_by_type_fetcher';
require('imagesloaded');
import generateUrl from '../utils/generate_url_with_slide_util';
import generateFullHref from '../utils/generate_full_href';
import ads from '../services/admanager';
import Scroller from './scroller';
import ModalShareButtons from './modal-share-buttons';
import $ from 'jquery';
import VerticalResponsive from './vertical-responsive';
import _ from 'underscore';
import trackOmniture from '../utils/track_omniture';

class PhotoGallery {
    /**
     * The PhotoGallery class is the meat of the functionality for photo galleries.
     * This class transforms slides markup from inlineslideshow header into
     * photogallery slides.
     * @param  {object} config props for $slideshow {object} (jquery obj
     *                          built from the inlineslideshow markup),
     *                          modalObj {object} is the parent modal
     *                          slideIndexParam {number} is the slide index provided in url,
     *                          isMobile  {boolean}
     * @return {obj} instance of PhotoGallery
     */
    constructor(config) {
        this.$slideshow = config.$slideshow.clone();
        this.$slides = config.$slideshow.find('.slide').clone();
        this.modalObj = config.modal;
        this.$modal = config.modal.$myself;
        this.slideIndexParam = config.slideNumberParam ? config.slideNumberParam - 1 : 0;
        this.closeButton = this.$modal.find('.photo-gallery__modal__close');
        this.modalShareButtons = new ModalShareButtons(config.$slideshow.data('url'));
        this.isMobile = config.isMobile;
    }
    /**
     * removes DOM associated with $modal, $slideshow, $slides,
     * deletes this instance of PhotoGallery's props
     * if there is a slick carousel it also destroys the slideshow and removes it
     * from the DOM
     * @return {undefined}
     */
    destroy() {
        this.$modal.off('keydown');
        if (this.$slickCarousel) {
            this.$slickCarousel.slick('unslick');
            this.$slickCarousel.off();
            this.$slickCarousel.remove();
            this.$slickCarousel = null;
        }
        this.$modal.remove();
        this.$slideshow.remove();
        this.$slides.remove();
        let properties = Object.getOwnPropertyNames(this);
        for (let i = 0; i < properties.length; i++) {
            let prop = properties[i];
            this[prop] = null;
        }

    }
    /**
     * build the menu markup for the photogallery.
     * Our menu contains close and share functionalities
     * The close button is repurposed from the parent Modal obj, but placed in a
     * new location in the DOM tree
     * @return {string} the template string containing markup for the menu
     */
    buildMenuMarkup() {
        let shareButtonLauncher = '';
        if (this.isMobile) {
            shareButtonLauncher = `<button class="photo-gallery__modal__share"><span class="photo-gallery__modal__share__icon"><i class="icon-fat-share"></i></span>Share</button>`;
        } else {
            let $shareButtons = this.modalShareButtons.$shareButtons;
            $shareButtons.each((index, item)=> {
                let $shareButton = $(item);
                $shareButton.css('color', 'white');
                shareButtonLauncher += $shareButton[0].outerHTML;
            });

        }

        this.closeButton.remove();
        if (this.isMobile) {
            this.closeButton.prepend('<span class="photo-gallery__modal__close__icon"><i class="icon-fat-close"></i></span>');
        } else {
            this.closeButton.prepend('<span class="photo-gallery__modal__close__icon"><i class="icon-close"></i></span>');
        }
        return `<div class="photo-gallery__modal__menu">${shareButtonLauncher} ${this.closeButton[0].outerHTML}</div>`;

    }

    /**
     * build markup for mobile ad slots
     * @return {string} template string for mobile ads
     */
    buildAdSlot() {
        return `<div class="ad-wrapper ad-wrapper-small ad-wrapper-small-inline no-border photo-gallery__modal__ad-wrapper"><div class="small-ad ad-unit" data-advertising="mobilerectangle"><div class='dart-ad'></div></div></div>`;
    }

    /**
     * checks userAgent to see if it is Android
     * @return {boolean} is the userAgent Android?
     */
    determineIfIsAndroid() {
        let ua = _get(navigator, 'userAgent');
        let isAndroid;
        if  (ua) {
            ua = ua.toLowerCase();
            isAndroid = ua.indexOf("android") > -1;
        }
        return isAndroid;
    }
    /**
     * determines current site and builds markup for a pared down nav for the modal
     * @return {string} template string for nav
     */
    buildNav() {
        let logoLookup = {
            fastcodesign: '//d.fastcompany.net/asset_files/-/2016/05/19/Logos-white-47.svg',
            fastcocreate: '//c.fastcompany.net/asset_files/-/2016/05/19/Logos-white-46.svg',
            fastcoexist: '//a.fastcompany.net/asset_files/-/2016/05/19/Logos-white-48.svg',
            fastcompany: '//a.fastcompany.net/asset_files/-/2016/05/18/FC-Bug.svg'
        };
        let currentSite = bootstrap_obj.site.slug;
        let currentSiteUrl = bootstrap_obj.site.url;

        return `
        <nav class="modal_nav">
            <div class="ad-wrapper ad-wrapper-medium navbar-ad">
                <div class="ad-unit medium-ad leaderboard-ad" data-advertising="slideshowleaderboard">
                    <div class="dart-ad"></div>
                </div>
            </div>
            <div class="ad-wrapper ad-wrapper-large navbar-ad photo-gallery__modal__nav-bar-ad--large">
                <div class="ad-unit large-ad leaderboard-ad" data-advertising="slideshowleaderboard">
                    <div class="dart-ad"></div>
                </div>
            </div>
            <div class="photo-gallery__modal__nav-bar-wrapper">
                <a href="${currentSiteUrl}">
                    <img class="photo-gallery__modal__nav-bar-logo photo-gallery__modal__nav-bar-logo--${currentSite}"
                    src="${logoLookup[currentSite]}"/>
                </a>
            </div>
            <div class="ad-wrapper ad-wrapper-small no-border mlb article header-ad-slideshow">
                <div class="small-ad ad-unit mobileleader-ad photo-gallery__modal__header-mlb" data-advertising="mobileleaderboard">
                    <div class="dart-ad"></div>
                </div>
            </div>
        </nav>`;
    }
    /**
     * iterate through $slides to build the proper markup for photoGallery slides
     * @param  {string} htmlString to add string containing slides markup to
     * @return {string}            html string updated with slides markup
     */
    buildSlides(htmlString) {
        let transformedHtmlString = htmlString;
        let isAndroid = this.determineIfIsAndroid();
        transformedHtmlString += `<div class="js-photo-gallery__modal__slide__wrapper photo-gallery__modal__slide__wrapper">`;
        this.$slides.each((index, slide) => {
            let $slide = $(slide);
            let $img = $slide.find('img');

            if ($img.length) {
                let assetURL = $img.data('lazy');
                assetURL = assetURL.replace('slideshow_large', 'w/800/h/600/scale');
                $img.attr('data-lazy', assetURL);
                $img.addClass('photo-gallery__modal__slide__poster');
                $img.addClass('js-photo-gallery__modal__slide__poster');
            }

            let $video = $slide.find('video');
            let caption = $slide.data('caption');
            let slideNumber = index + 1;
            $slide.find('noscript').remove();
            if (this.isMobile || index === this.slideIndexParam) {
                $img.attr('src', $img.attr('data-lazy'));
                $img.attr('data-lazy', '');
            }


            if ($video.length && isAndroid) {
                $video.attr('onclick', 'this.play();');
            }

            if ($video.length) {
                const $sources = $video.find('source');
                let poster = $video.attr('poster');
                poster = poster && typeof poster === 'string' ? poster.replace('slideshow_large', 'w/800/h/600/scale') : '';
                $video.attr('poster', poster);
                $sources.each((i, source) => {
                    let $source = $(source);
                    let src = $source.attr('data-src');
                    src = src && typeof src === 'string' ? src.replace('slideshow_large', 'w/800/h/600/scale') : '';
                    if (index === this.slideIndexParam) {
                        $source.attr('src', src);
                        $source.removeAttr('data-src');
                    } else {
                        $source.attr('data-src', src);
                    }


                });
                // $video.addClass('js-photo-gallery__modal__slide__poster');
            }

            let updatedCaption = $($.parseHTML(caption));
            updatedCaption.find('p').addClass('photo-gallery__modal__slide__caption__p');
            $slide.append(updatedCaption);
            // an ad every fourth spot
            if ((index - 2) % 3 === 0) {
                $slide.append(this.buildAdSlot());
            }
            transformedHtmlString += '<figure class="photo-gallery__modal__slide js-photo-gallery__modal__slide-' + slideNumber + '">' + $slide.html() + '</figure>';
        });

        transformedHtmlString += `</div>`;
        return transformedHtmlString;
    }

    buildRecircSlide() {
        const currStoryNid = window.bootstrap_id;
        const storiesPromise = getByTypeFetcher();
        const $lastSlide = $('<div class="js-photo-gallery__modal__slide photo-gallery__modal__slide photo-gallery__modal__slide--last-slide"></div>');
        return storiesPromise.then(function onResolveStoriesPromise(response) {
            const stories = response.post;
            stories.filter((story) => {
                return story.nid.toString() !== currStoryNid;
            }).filter((story, index) => {
                return index < 4;
            }).forEach((story, index) => {
                let $img = $(`<img src="${story.largePosterImage}">`);
                let $figure = $(`<figure></figure>`);
                let $anchor = $(`<a href="${story.url}"></a>`);
                let $article = $(`<article></article>`);
                let $title = $(`<h4>${story.title}</h4>`);
                const $moreStoriesHeading = $(`<h4 class="photo-gallery__modal__slide--last-slide__more-stories-heading">More Slideshows</h4>`);


                let articleClassList = `photo-gallery__modal__slide--last-slide`;
                let figureClassList = ``;
                let imgClassList = ``;
                let h4ClassList = ``;

                if (index === 0) {
                    articleClassList += `__next-story`;
                    figureClassList += `${articleClassList}__figure`;
                    imgClassList += `${articleClassList}__poster`;
                    h4ClassList += `${articleClassList}__title`;
                }

                if (index !== 0) {
                    articleClassList += `__more-stories`;
                    figureClassList += `${articleClassList}__figure`;
                    imgClassList += `${articleClassList}__poster`;
                    h4ClassList += `${articleClassList}__title`;
                    articleClassList += ` ${articleClassList}-${index}`;
                }

                $img.addClass(imgClassList);
                $figure.addClass(figureClassList);
                $title.addClass(h4ClassList);
                $article.addClass(articleClassList);
                $figure.append($img);
                $anchor.append($figure, $title);
                $article.append($anchor);
                $lastSlide.append($article);

                if (index === 0) {
                    $lastSlide.append($moreStoriesHeading);
                }
            });

            return $lastSlide[0].outerHTML;
        }).catch(function onStoriesPromiseError() {
            return null;
        });

    }
    /**
     * Renders the photogallery instance to the Modal, adds event listenrs and
     * reinstantiates ads and other libraries we need for a post.
     * Instantiates a new slideshow if desktop
     * @return {undefined}
     */
    render() {
        let htmlString = ``;
        let navWrapperString = `<nav class="modal_nav"></nav>`;
        let nav = this.buildNav();
        const $nav = $(nav);
        const isDesktop = !this.isMobile;
        // our menu are the controls for two different parts of the
        // code. 1) the close button for the MODAL and 2) the share
        // share button which belong to the PHOTOGALLERY class.
        // the $menu takes the close button from the modal and assigns it
        // in the DOM to the photoGallery

        // modal >  closeButton , photogallery for modal
        // becomes
        // modal > photogallery > menu > closeButton, shareButtons
        const $menu = this.constructMenu(galleryScroller);

        // Create headline markup
        const headlineMarkup = `<h1 class="photo-gallery__modal__hed">${this.$slideshow.data('title')}</h1>`;

        // On mobile, append $menu to the DOM as a sibling of the modal. On desktop, append $menu to the navbar within the modal
        if (this.isMobile) {
            this.$modal.parent().append($menu);
        } else {
            $nav.find('.photo-gallery__modal__nav-bar-wrapper').append(headlineMarkup, $menu);
        }

        // Give the navbar a wrapper
        htmlString += `${navWrapperString}`;

        // Open up the modal body content wrapper div
        htmlString += `<div class="photo-gallery__modal__body-wrapper">`;

        // On mobile, add the eyebrow
        if (this.isMobile) {
            htmlString += `
            <div class="photo-gallery__modal__eyebrow">
                <p class="photo-gallery__modal__eyebrow-text left">Gallery</p>
            </div>`;
            htmlString += headlineMarkup;
        }

        // Bring in the slides
        let htmlStringWithSlides = this.buildSlides(htmlString);

        // On desktop, add the right rail ad. Also, close the modal body content wrapper div.
        if (isDesktop) {
            htmlStringWithSlides += `
            <div class="photo-gallery__modal__ad  ad-wrapper ad-wrapper ad-wrapper-large ad-wrapper-header">
                <div id="header-imu" class="header-ad ad-unit large-ad" data-advertising="slideshowhalfpage">
                    <div class="dart-ad"></div>
                </div>
            </div></div>`;
        }

        // this is where our big html string is appeneded to ACTUAL DOM
        this.$modal.append(htmlStringWithSlides);
        this.$modal.find('.modal_nav').replaceWith($nav);

        let galleryScroller;
        if (this.isMobile) {
            ads();
            require('./media-scaler')({ fitvidsSelector: `.photo-gallery__modal` });
            // find the margin-top of the first slide
            let offset = $('.photo-gallery__modal__slide').css('margin-top');

            const scrollerConfig = {
                slideShowUrl: this.$slideshow.data('url'),
                $slides: $('[class*="js-photo-gallery__modal__slide-"]'),
                slideIndexParam: this.slideIndexParam,
                offset: offset
            };

            galleryScroller = new Scroller(scrollerConfig);
            this.$modal.imagesLoaded(function () {
                galleryScroller.turnSlidesIntoScenes();
            });
        }

        if (isDesktop) {
            this.$slickCarousel = createSlideshow(
                '.js-photo-gallery__modal__slide__wrapper',
                true,
                this.slideIndexParam + 1,
                {
                    infinite: false,
                    prevArrow: '<button type="button" class="slick-prev"><i class="icon-caret"></i></button>',
                    nextArrow: '<button type="button" class="slick-next"><i class="icon-caret"></i></button>',
                    accessibility: false
                    // adaptiveHeight: true
                },
                true,
                (fullHref) => { window.history.replaceState(null, '', fullHref); }
            );

            const attachClickEventListenerForSlide = function (slick, currentSlideIndexParam) {
                let currentSlideIndex = currentSlideIndexParam || 0;
                const currentSlide = slick.$slides[currentSlideIndex];
                const $currentSlide = $(currentSlide);
                if (currentSlideIndex !== slick.$slides.length - 1) {
                    $currentSlide.on('click', function slideClickHandler(event) {
                        const pixelWidth = $(this).innerWidth();
                        const pixelOffset = $(this).offset();
                        const x = event.pageX - pixelOffset.left;
                        let slideIndexChangeValue = 1;
                        if (pixelWidth / 2 > x) {
                            slideIndexChangeValue = -1;
                            trackOmniture('event30', currentSlideIndex);
                        } else {
                            let currentSlideNumber = currentSlideIndex;
                            trackOmniture('event29', currentSlideNumber + 2);
                        }
                        slick.$slider.slick('slickGoTo', currentSlideIndex + slideIndexChangeValue);
                        $(this).off('click', slideClickHandler);
                    });
                }
            };

            const hideArrow = function ($arrow, slideIndexWhenToHide, currentSlideIndex) {
                if (currentSlideIndex === slideIndexWhenToHide) {
                    $arrow.hide();
                } else {
                    $arrow.show();
                }
            };

            const hideArrows = function (slick, currentSlideIndex) {
                hideArrow(slick.$nextArrow, slick.$slides.length - 1, currentSlideIndex);
                hideArrow(slick.$prevArrow, 0, currentSlideIndex);
            };

            const adjustForVerticalResponsiveness = function (slider) {
                const verticalResponsive = new VerticalResponsive({
                    parentContainer: slider,
                    className: 'js-photo-gallery__modal__slide__poster'
                });
                verticalResponsive.adjustStyles();
                verticalResponsive.off();
            };

            this.$slickCarousel.on('reInit', function (event, slick) {
                // debugger;
                attachClickEventListenerForSlide(slick, slick.currentSlide);
                hideArrows(slick, slick.currentSlide);
                require('./media-scaler')({ fitvidsSelector: `.photo-gallery__modal` });
                adjustForVerticalResponsiveness(slick.$slider);
                if (slick.currentSlide === 0) {
                    let originalUrl = window.location.pathname;
                    window.history.replaceState(null, '', generateFullHref(generateUrl(originalUrl, slick.currentSlide)));
                }
            });

            const debounceVerticalResponsive = _.debounce(adjustForVerticalResponsiveness.bind(null, this.$slickCarousel), 300);
            $(window).resize(debounceVerticalResponsive);

            this.$slickCarousel.on('afterChange', function (event, slick, currentSlideIndex) {
                attachClickEventListenerForSlide(slick, currentSlideIndex);
                hideArrows(slick, currentSlideIndex);
                require('./media-scaler')({ fitvidsSelector: `.photo-gallery__modal` });
                // const verticalResponsive = new VerticalResponsive({
                //     parentContainer: slick.$slides[currentSlideIndex],
                //     className: 'full_width'
                // });
                // verticalResponsive.init();
            });

            this.buildRecircSlide().then((lastSlideMarkup) => {
                if (lastSlideMarkup) {
                    this.$slickCarousel.slick('slickAdd', lastSlideMarkup);
                }
            });

            this.$modal.on('keydown', this.keyControlSlick.call(this));
        }
    }

    /**
     * Builds the menu, which inclides the share buttons and close button for the modal.
     * @param  {obj} galleryScroller instance of Gallery Scroller
     * @return {object}                jquery object of menu
     */
    constructMenu(galleryScroller) {
        const shareLauncherClickEvent = () => {
            const onClickCloseShareModal = () => {
                this.$modal.removeClass('photo-gallery__modal--no-scroll');
                if (this.isMobile) {
                    this.modalShareButtons.$shareModal.find('.close-modal').off('click', onClickCloseShareModal);
                }
            };
            this.$modal.addClass('photo-gallery__modal--no-scroll');

            if (this.isMobile) {
                this.modalShareButtons.shareModalClick();
                this.modalShareButtons.$shareModal.find('.close-modal').on('click', onClickCloseShareModal);
            }
        };

        const $menu = $(this.buildMenuMarkup());

        this.$modal.on($.modal.CLOSE, ()=> {
            $menu.remove();
            this.modalShareButtons.restoreShareURIs();
            this.modalShareButtons.destroy();
            $shareLauncher.off('click', shareLauncherClickEvent);
            if (galleryScroller) {
                galleryScroller.destroy();
            }
            this.modalObj.close();
            this.modalObj = null;

            window.history.replaceState(null, '', generateFullHref(generateUrl(window.location.pathname, -1)));
        });

        const $shareLauncher = $menu.find('.photo-gallery__modal__share');
        $shareLauncher.on('click', shareLauncherClickEvent);

        return $menu;
    }

    keyControlSlick() {
        return (event) => {
            const keyPressed = event.keyCode;
            const currentSlideIndex = this.$slickCarousel.slick('slickCurrentSlide');
            if (keyPressed === 37) {
                this.$slickCarousel.slick('slickGoTo', currentSlideIndex - 1);
                trackOmniture('event30', currentSlideIndex);
            }
            if (keyPressed === 39) {
                this.$slickCarousel.slick('slickGoTo', currentSlideIndex + 1);
                trackOmniture('event29', currentSlideIndex + 2);
            }
            this.$modal.focus();
        };
    }

}

export default PhotoGallery;
